<div class="page-loader" *ngIf="showLoader">
  <div>
    <i class="fa fa-4x fa-spinner fa-pulse"></i>
  </div>
</div>
